export const withProtocol = (url: string, protocol = "https"): string => {
  return /^\/\//.test(url) ? `${protocol}:${url}` : url;
};
